import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import '../assets/css/BubbleMobile.scss';

const Bubble = ({ condition, text }) => {
  return (
    <div className="col-12 p-0 d-sm-none">
      <div className="row circle-box-mobile mx-0">
        <div className="col-auto px-0">
        <div className={'circle-' + (condition ? 'red-mobile' : 'black-mobile')}>
          {condition ? (
            <FontAwesomeIcon icon={faCheck} className="p-circle-check-mobile" />
          ) : (
            <FontAwesomeIcon icon={faTimes} className="p-circle-times-mobile" />
          )}
        </div>
        </div>
        <div className="col-auto">
        <p style={{ marginTop: '11px' }}>{text}</p>
        </div>
      </div>
    </div>
  );
};

export default Bubble;
